// const MICROCYCLE_PREFIX = USER_FITNESS_PREFIX + "/v1/microcycle/managed";
//
// const fetchUserFitnessPlan: string = USER_FITNESS_PREFIX + "/user_fitness_plans/microCycle?";
// const microcylePrefixUrl: string = MICROCYCLE_PREFIX + "/search/detail?query=";
// const saveFitnessTemplateUrl: string = MICROCYCLE_PREFIX + "/save";
// const assignFitnessPlanToUser: string = MICROCYCLE_PREFIX + "/$planId/duplicate?";
// const fetchUserFitnessManagedPlan: string = MICROCYCLE_PREFIX + "/user/search?";
// const publishUserFitnessPlan: string = USER_FITNESS_PREFIX + "/micro_cycles/save/managedMicroCycleId?managedMicroCycleId=$planId";
// const deleteUserFitnessPlan: string = MICROCYCLE_PREFIX + "/$planId/delete";
// const savePublishedUserFitnessPlan: string = USER_FITNESS_PREFIX + "/micro_cycles/save";
// const searchFitnessGoals: string = USER_FITNESS_PREFIX + "/goals/search";

import {IUserFitnessApis} from "./IUserFitnessApis";

export default class UserFitnessApis implements IUserFitnessApis {
	// fetchUserFitnessPlan(requestParams: IUserFitnessPlanRequestParams): Promise<IUserFitnessPlan> {
	// 	const url = fetchUserFitnessPlan + ApiUtils.requestToQueryParams(requestParams);
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	// fetchMicrocyleById(microcyleId: number): Promise<IPaginatedMicrocycles> {
	// 	const url = `${microcylePrefixUrl}id.eq:${microcyleId}`;
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	// saveFitnessTemplate(requestBody: IMicrocycle) {
	// 	return ApiUtils.apiPostRequest(saveFitnessTemplateUrl, JSON.stringify(requestBody));
	// }
	//
	// saveUserFitnessPlan(requestBody: IMicrocycle) {
	// 	return ApiUtils.apiPostRequest(saveFitnessTemplateUrl, JSON.stringify(requestBody));
	// }
	//
	// fetchAllFitnessPlans(params: { [key: string]: { value: string | number; query: string } }, paginationParams?: IPaginationParams) {
	// 	const queryParams =
	// 		params &&
	// 		Object.keys(params)
	// 			.map((key) => {
	// 				if (params[key].query === "eq") {
	// 					return `${key}.eq:${params[key].value}`;
	// 				}
	// 				if (params[key].query === "like") {
	// 					return `${key}.like:%25${params[key].value}%25`;
	// 				}
	// 			})
	// 			.join(";");
	//
	// 	let url = microcylePrefixUrl + queryParams;
	// 	if (paginationParams) {
	// 		url += "&" + ApiUtils.requestToQueryParams(paginationParams);
	// 	}
	//
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	// assignFitnessPlan(requestParams: IUserFitnessPlanRequestParams, selectedPlanId: number) {
	// 	const url = assignFitnessPlanToUser.replace("$planId", selectedPlanId.toString()) + ApiUtils.requestToQueryParams(requestParams);
	// 	return ApiUtils.apiPostRequest(url, null);
	// }
	//
	// fetchUserFitnessManagedPlan(requestParams: IUserFitnessManagedPlanParams) {
	// 	const url = fetchUserFitnessManagedPlan + ApiUtils.requestToQueryParams(requestParams);
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	// publishUserFitnessPlan(planId: number) {
	// 	const url = publishUserFitnessPlan.replace("$planId", planId.toString());
	// 	return ApiUtils.apiPostRequest(url, null);
	// }
	//
	// deleteUserFitnessPlan(planId: number) {
	// 	const url = deleteUserFitnessPlan.replace("$planId", planId.toString());
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	// savePublishedUserFitnessPlan(reqBody: IUserFitnessPlan) {
	// 	return ApiUtils.apiPostRequest(savePublishedUserFitnessPlan, JSON.stringify(reqBody));
	// }
	//
	// fetchFitnessGoals() {
	// 	return ApiUtils.apiGetRequest(searchFitnessGoals);
	// }
}
